import * as React from 'react';
import type { IconProps } from './types';

export const PageIcon = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => {
  const { color = 'currentColor', size = 24, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
      {...other}
    >
      <path
        d="M8 0.75H24C24.0911 0.75 24.1793 0.777281 24.2539 0.827148L24.3232 0.883789L35.1162 11.6768C35.2019 11.7625 35.25 11.8788 35.25 12V36C35.25 37.7949 33.7949 39.25 32 39.25H8C6.20507 39.25 4.75 37.7949 4.75 36V4C4.75 2.20507 6.20508 0.75 8 0.75Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path d="M24 0.5V8C24 10.2091 25.7909 12 28 12H35.5" stroke={color} strokeWidth="1.5" />
    </svg>
  );
});
